import React from "react";
import {Button, Modal, ModalBody, ModalHeader} from "reactstrap";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import {Collections, Objects, Parts} from "components";
import UserRoles from "constants/UserRoles";
import {Call_Geocode_API} from "../../constants/Utilities";
import API from "@beardeddevops/react.api";
import Types from "../../constants/Types";
import {confirmAlert} from "react-confirm-alert";
import {Link, Prompt} from "react-router-dom";
import moment from "moment-timezone";
import {Tooltip} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import ManagerCharts from "./ManagerCharts";

const initialState = {
	customer: null,
	location: null,
	currentRegion: null,
	fesInRange: []
};

class CustomerQuickEdit extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			...initialState,
			isSaveDisabled: false,
		};

		this.ticketFormRef = React.createRef();
		this.customerFormRef = React.createRef();
		this.tableRef = React.createRef();
		this.scheduleFormRef = React.createRef();
		this.ticketSubmissionQueued = false;
		this.state.ticketSave = false;
		this.state.currentRegion = null;
		this.state.search = '';
		this.state.shouldBlockRedirect = false;
		this.state.initialCustomerFormRef = null;
		this.state.initialTicketFormRef = null;
		this.state.fePkeys = [];
		this.state.reschedule_tickets = [];
		this.state.override_warning = false;
		this.state.override_day_off_warning = false;
		this.state.override_revisit_warning = false;
		this.state.follow_up = false;
		this.state.fromExistingCustomer = false;
		this.state.dispatch_count = 0;
		this.state.pending_count = 0;
		this.state.fdGraphModal = false;

		window.addEventListener("beforeunload", this.beforeUnloadFunction);
	}

	componentWillUnmount() {
		window.removeEventListener("beforeunload", this.beforeUnloadFunction);
	}

	beforeUnloadFunction = (ev) => {
		if (this.state.shouldBlockRedirect) {
			ev.preventDefault();
			return ev.returnValue = 'Are you sure you want to close?';
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.customerFormRef !== null && this.state.initialCustomerFormRef === null) {
			this.state.initialCustomerFormRef = {...this.customerFormRef.current};
		}

		const pending_count = localStorage.getItem('pending_count');
		const dispatch_count = localStorage.getItem('dispatch_count');

		if ((pending_count || dispatch_count) && (pending_count !== this.state.pending_count || dispatch_count !== this.state.dispatch_count)) {
			this.setState({pending_count: pending_count, dispatch_count: dispatch_count})
		}

		if (this.ticketFormRef !== null && this.state.initialTicketFormRef === null) {
			this.state.initialTicketFormRef = {...this.ticketFormRef.current};
		}
		if (this.state.initialCustomerFormRef && this.state.initialTicketFormRef && !this.state.ticketSave) {
			let initialcustkeys = Object.keys(this.state.initialCustomerFormRef.state);
			let initialticketkeys = Object.keys(this.state.initialTicketFormRef.state)
			let diffKey = null;
			initialcustkeys.forEach((key) => {
				if (this.customerFormRef.current.state[key] !== this.state.initialCustomerFormRef.state[key]) {
					this.state.shouldBlockRedirect = true;
					diffKey = key;
				}
			})
			initialticketkeys.forEach((key) => {
				if (this.ticketFormRef.current.state[key] !== this.state.initialTicketFormRef.state[key] && key !== 'tickets_types' && key !== 'type') {
					this.state.shouldBlockRedirect = true
					diffKey = key;
				}
			})
		}
	}

	// TBD
	loadCustomer = async (customer, location, currentRegion) => {
		this.setState({override_warning: false, override_revisit_warning: false, fromExistingCustomer: true})
		if (customer.blacklisted) {
			confirmAlert({
				title: 'Customer Blacklisted',
				message: "This customer has been blacklisted. You will not be able to book this customer's appointment until the blacklist has been lifted. Please contact a manager and ask them to check the customer's notes.",
				buttons: [
					{
						label: 'I Understand',
						onClick: () => {
						}
					}
				],
				closeOnClickOutside: false,
				closeOnEscape: false
			});
		}
		this.state.reschedule_tickets = [];
		let latitude = null;
		let longitude = null;
		const geo = await Call_Geocode_API(
			location.street_1 + ", " + location.city + " " + location.state
		);
		if (geo?.latitude != null && geo?.longitude != null) {
			latitude = geo.latitude;
			longitude = geo.longitude;
		}
		await this.setAddress([location.latitude, location.longitude, currentRegion])
		if (location.latitude && location.longitude && (latitude === location.latitude && longitude === location.longitude)) {
			this.setState({
				customer,
				location,
				currentRegion,
				regionPkey: currentRegion
			});
		} else {
			//only gets called once, but we can use the results multiple times
			location.latitude = latitude;
			location.longitude = longitude;
			let tmodel = new API.BuildClass(Types.Customers_Locations._name, API.RequestType.READ);
			tmodel.parent = customer.pkey
			tmodel.object = location
			tmodel.submit(null, 'POST', true)
			//call regions get here and pass lat/long to get distance done
			this.setState({
				customer,
				location,
				currentRegion,
			});
		}

		if (this.ticketFormRef && this.ticketFormRef.current.state.type === 3) {
			await this.checkRevisit();
		}
		let model = new API.BuildClass(Types.Tickets._name, API.RequestType.READ_ALL);
		this.request = 'GET_TICKET_RESCHEDULE'
		model.filter = {
			'customer': customer.pkey
		}
		const data = await model.submit(null, this.request);
		if (data.items.length > 0) {
			this.setState({reschedule_tickets: data.items})
		}
	};

	changeSearch = (search) => {
		this.setState({search});
	}

	handleSave = async (event) => {
		event.preventDefault();
		this.state.shouldBlockRedirect = false;
		setTimeout(() => this.setState({isSaveDisabled: false}), 2000);
		if (!this.state.ticketSave) {
			this.setState({ticketSave: true});
		}
		await this.handleCustomerSave(event);

		if (this.tableRef?.current) {
			this.tableRef.current.reloadTable.call(this.tableRef.current);
		}
	};

	handleData = async (customer) => {
		// Only used when submitting a new customer, bypasses customerLocationSave as it is only used for existing customers
		let location = customer.locations;

		if (!location)
			throw new Error("handleData: new customer must have a location");

		this.setState({customer, location});

		await this.handleSubmitTicket();
	};

	handleSubmitTicket = async () => {
		let {customer, location} = this.state;
		let {current} = this.ticketFormRef;

		if (!current) {
			this.state.ticketSave = false;
			throw new Error("handleSubmitTicket: ticket form ref should be defined");
		}


		if (!customer || !location) {
			this.state.ticketSave = false;
			throw new Error("handleSubmitTicket: customer or location is missing");
		}

		current.model.object.customer = current.state.customer = customer.pkey;
		current.model.object.location = current.state.location = location.pkey;
		current.state.startAppt = this.scheduleFormRef.current.state.startAppt;
		current.state.endAppt = this.scheduleFormRef.current.state.endAppt;
		current.state.field_engineer = this.scheduleFormRef.current.state.selectedFE;
		current.state.selectedDay = this.scheduleFormRef.current.state.filterDate.split('T')[0];
		current.state.override_warning = this.state.override_warning;
		current.state.override_day_off_warning = this.state.override_day_off_warning;
		current.state.override_revisit_warning = this.state.override_revisit_warning;
		current.state.follow_up = !!this.state.follow_up && !!this.state.fromExistingCustomer;
		if (current.model && current.model.object) {
			current.model.object.follow_up = current.state.follow_up;
		}

		if (this.state.override_warning === false && current.state.description && current.state.type && current.state.summary && current.state.field_engineer && current.state.startAppt && current.state.endAppt) {
			this.state.override_warning = true;
		}
		// if (this.state.override_day_off_warning === false && current.state.description && current.state.type && current.state.summary && current.state.field_engineer && current.state.startAppt && current.state.endAppt) {
		// 	this.state.override_day_off_warning = true;
		// }
		// if (this.state.override_revisit_warning === false && current.state.description && current.state.type && current.state.summary && current.state.field_engineer && current.state.startAppt && current.state.endAppt) {
		// 	this.state.override_revisit_warning = true;
		// }

		try {
			await current.handleSubmit.call(current, null, false, false);
		} catch (e) {
			this.state.shouldBlockRedirect = true;
			this.state.ticketSave = false;
		}
	};


	handleCustomerSave = async () => {
		let {current} = this.customerFormRef;

		if (!current) {
			this.state.ticketSave = false;
			throw new Error("handleCustomerSave: customer form ref should be defined");
		}

		try {
			await current.handleSubmit.call(current, null, true, false);
		} catch (e) {
			// Ignore, if customer creation fails it will be caught in the framework - cross-origin error from Google scripts API call in dev
			this.state.shouldBlockRedirect = true;
			this.state.ticketSave = false;
		}
	};

	handleTicketAfterSave = (data) => {
		// TBD - expected behavior for this view?

		//Maybe implement this later?
		localStorage.setItem('ticketToggled', 'no');
		localStorage.removeItem('users'); //doing this so that ticket correctly pops after creation no matter what
		localStorage.removeItem('regions'); //doing this so that ticket correctly pops after creation no matter what
		localStorage.removeItem('date'); //doing this so that ticket correctly pops after creation no matter what
		this.props.history.push(`/dispatch/calendar/` + data.pkey);
		// this.props.history.push(`/dispatch/calendar`);
		// this.props.history.push(`/tickets/` + data.pkey + `/schedule`);
	};

	handleClear = () => {
		confirmAlert({
			title: 'Confirm Clear',
			message: 'Are you sure you want to clear all information?',
			buttons: [
				{
					label: 'Yes',
					color: 'danger',
					onClick: async () => {
						await this.setState({
							customer: null,
							location: null,
							currentRegion: null,
							key: Math.random(),
							search: '',
							regionPkey: null,
							selectedAddress: null,
							fesInRange: [],
							reschedule_tickets: [],
							follow_up: false,
							fromExistingCustomer: false
						});
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	}

	ticketChangeRegion = (currentRegion, regionPkey) => {
		this.setState({currentRegion, regionPkey});
	}

	setAddress = async ([lat, lng, region]) => {
		this.setState({selectedAddress: {lat: lat, lng: lng}, filterRegion: region ?? 1, fesInRange: 'loading', regionPkey: region ?? 1})

		if (region && lat && lng) {
			//call trip_fees to see if this customer would be charged a trip fee
			let tripFees = new API.BuildClass(Types.Trip_Fees._name, API.RequestType.READ);
			tripFees.filter = {};
			tripFees.filter.region = region;
			tripFees.filter.lat = lat;
			tripFees.filter.lng = lng;
			const result = await tripFees.submit(null, 'GET_CHECK_CUSTOMER', true);
			if (result && result.response && result.response.includes('This customer will require a trip fee.')) {
				confirmAlert({
					title: 'Trip Fee Notification',
					message: result.response,
					buttons: [
						{
							label: 'I Understand',
							onClick: () => {
							}
						}
					],
					closeOnClickOutside: false,
					closeOnEscape: false
				});
			}
		}

		this.setState({
			fesInRangeFilter: {
				'latitude': lat,
				'longitude': lng,
				'region': region ?? 1,
			}
		})

		let modelAddressSelected = new API.BuildClass(Types.Dispatch._name, API.RequestType.CREATE);
		modelAddressSelected.submit(null, 'PUT_ADDRESS_SELECTED', true);
	}

	handleCustomerAfterSave = async (data) => {
		if (!!data.locations) {
			await this.handleData(data);
		} else {
			await this.setState({customer: data})
			await this.customerFormRef.current.handleCustomerLocationSave();
		}
	};

	updateFilterDate = (date) => {
		this.setState({filterDate: moment(date).format('YYYY-MM-DD'), fesInRange: 'loading'})
		let modelAvailabilityDayWalked = new API.BuildClass(Types.Dispatch._name, API.RequestType.CREATE);
		modelAvailabilityDayWalked.submit(null, 'PUT_AVAILABILITY_DAY_WALKING', true);
	}

	processPhoneString(input) {
		const regex = /^[0-9-]+$/; // Regex to allow only numbers and dashes
		if (regex.test(input)) {
			return input.replace(/-/g, ''); // Remove all dashes if valid
		}
		return ''; // Return null if the string contains invalid characters
	}

	setOverride = async () => {
		if (this.state.override_warning !== false) {
			this.setState({override_warning: false})
		}
		if (this.state.override_day_off_warning !== false) {
			this.setState({override_day_off_warning: false})
		}
		if (this.scheduleFormRef.current.state.selectedFE) {
			//call api and see if the FE is off on this day
			let dayOffModel = new API.BuildClass(Types.Users._name, API.RequestType.READ);
			dayOffModel.filter = {};
			dayOffModel.filter.filterDate = this.state.filterDate;
			dayOffModel.filter.engineer = this.scheduleFormRef.current.state.selectedFE;
			try {
				await dayOffModel.submit(null, "GET_DAY_OFF", true);
				this.setState({override_day_off_warning: false})
			} catch (e) {
				this.setState({override_day_off_warning: true})
			}
		}
	}

	checkRevisit = async () => {
		if (this.state.customer && this.state.customer.pkey) {
			let revisitModel = new API.BuildClass(Types.Customers._name, API.RequestType.READ);
			revisitModel.object.pkey = this.state.customer.pkey;
			const response = await revisitModel.submit(null, 'POST_REVISIT', true)
			if (response) {
				if (response.last_ticket === 'waived') {
					this.setState({override_revisit_warning: true})
					confirmAlert({
						title: 'Revisit Notification',
						message: "The last ticket for this customer had waived steps of the Mandatory Four Point. This customer is not eligible for a free revisit.",
						buttons: [
							{
								label: 'I Understand',
								onClick: () => {
								}
							}
						],
						closeOnClickOutside: false,
						closeOnEscape: false
					});
				} else if (response.last_ticket === 'missing') {
					this.setState({override_revisit_warning: true})
					confirmAlert({
						title: 'Revisit Notification',
						message: "The last ticket for this customer cannot be found. This customer may not be eligible for a free revisit.",
						buttons: [
							{
								label: 'I Understand',
								onClick: () => {
								}
							}
						],
						closeOnClickOutside: false,
						closeOnEscape: false
					});
				}
			}
		}
	}

	render() {
		let {customer, location} = this.state;
		let {history, baseUrl, reloadShell, roles} = this.props;

		return (
			<React.Fragment>
				<Modal
					isOpen={this.state.fdGraphModal}
					toggle={() => this.setState({fdGraphModal: false})}
					size={"xl"}
					backdrop={true}
					title={'FD Ticket Graphs'}
				>
					<ModalHeader>
						FD Ticket Graphs
					</ModalHeader>
					<ModalBody>
						<Card>
							<CardContent>
								<ManagerCharts dispatchView={true}/>
							</CardContent>
						</Card>
					</ModalBody>
				</Modal>
				<Prompt message={'Navigating away will delete any unsaved appointment information.'} when={this.state.shouldBlockRedirect}/>
				<Card>
					<CardContent>
						<div className="row">
							<div className="col-3">
								<Objects.Customer
									key={this.state.key}
									ref={this.customerFormRef}
									id={customer?.pkey}
									history={history}
									onData={this.handleData}
									isCompany={true}
									hasModal={true}
									searchChange={this.changeSearch}
									findFE={true}
									submitTicket={this.handleSubmitTicket}
									locationPkey={location?.pkey}
									location={location}
									changeRegion={this.ticketChangeRegion}
									afterSave={this.handleCustomerAfterSave}
									setAddress={this.setAddress}
									forDispatch={true}
									resetBlacklist={(new_blacklisted) => this.setState({customer: {...this.state.customer, blacklisted: new_blacklisted}})}
								/>
								<h4 className="section-title">Engineers In Range of Customer</h4>
								<div className={'row'}>
									{this.state.selectedAddress ?
										this.state.fesInRange === 'loading' ?
											<b className={'flex-fill text-center'}>Loading Suggestions...</b> :
											typeof (this.state.fesInRange) === 'string' ?
												<div className={'col-12'}>
													<h5>
														{this.state.fesInRange}
													</h5>
												</div>
												: this.state.fesInRange.map((fe, index) => {
													return (
														<div className={index === 0 ? 'col-12' : 'col-6'} key={fe.NameFirst + '-range-card'}>
															<Card>
																<div className={'row'}>
																	<div className={index === 0 ? 'col-8' : 'col-12'}>
																		<Link target={"_blank"}
																		      to={'/dispatch/calendar?:' + fe.Pkey + '%20' + this.state.filterDate}>
																			<h5 style={{marginTop: 0, marginBottom: 0}}>
																				{fe.NameFirst} {fe.NameLast}
																			</h5>
																		</Link>
																	</div>
																	{index === 0 && <div className={'col-4'}>
																		<b>BEST OPTION</b>
																	</div>
																	}
																</div>
																<b>
																	{fe.appointmentPossibilities[0].slot}
																</b>
																<div className={'flex-end text-right'}>
																	{Math.round(fe.appointmentPossibilities[0].distance * 100) / 100} miles
																</div>
															</Card>
															{index === 0 && <hr style={{color: 'blue'}}/>}
														</div>
													)
												})
										:
										<div className={'col-12'}>
											<h5>
												Please select an address.
											</h5>
										</div>}
								</div>
							</div>

							<div className="col-4">
								<div className={'row'}>
									<div className="col">
										<Objects.Ticket
											key={this.state.key}
											ref={this.ticketFormRef}
											history={history}
											baseUrl={baseUrl}
											hasModal={true}
											customer={customer?.pkey}
											afterSave={this.handleTicketAfterSave}
											clear={(reset) => (this.reset = reset)}
											hideFE={true}
											dispatch_count={this.state.dispatch_count}
											triggerFDGraphModal={() => this.setState({fdGraphModal: true})}
											updateTicketType={async (value) => {
												this.setState({isRemoteWork: value === 2, isRevisit: value === 3, override_warning: false})
												//trigger the api call to check if the selected customer's last appt had the 4pt done if revisit
												if (value === 3) {
													await this.checkRevisit();
												} else {
													this.setState({override_revisit_warning: false})
												}
												//this.setState({isRemoteWork: value === 2})
											}}
										/>
										<Tooltip
											title={!this.state.fromExistingCustomer ? "Follow-Up is only available for existing customers selected from the list below." : ""}
											arrow
										>
											<span>
												<FormControlLabel
													control={
														<Checkbox
															checked={!!this.state.follow_up && !!this.state.fromExistingCustomer}
															disabled={!this.state.fromExistingCustomer}
															onChange={(e) => this.setState({follow_up: e.target.checked})}
															color="primary"
														/>
													}
													label="Follow-Up"
												/>
											</span>
										</Tooltip>
									</div>
								</div>
								<div className="row">
									<div className={'col'}>
										{!this.state.isRemoteWork && this.state.regionPkey &&
											<Objects.DispatchMap
												filterRegion={this.state.regionPkey}
												filterDate={this.state.filterDate}
												setRegion={(regionPkey) => {
													this.setState({regionPkey, selectedAddress: null})
												}}
												selectedAddress={this.state.selectedAddress ?? null}
												setColors={(userColors) => {
													this.setState({userColors})
												}}
												fePkeys={this.state.fePkeys}
												noCycle={true}
												noAutoRefresh={true}
											/>}
									</div>
								</div>
							</div>

							<div className="col-5">
								<div className="row">
									<div className="col">
										<Objects.ScheduleFieldEngineer
											key={this.state.key}
											ref={this.scheduleFormRef}
											history={history}
											baseUrl={baseUrl}
											location={this.state.regionPkey}
											clear={(reset) => (this.reset = reset)}
											updateFilterDate={this.updateFilterDate}
											pending_count={this.state.pending_count}
											triggerFDGraphModal={() => this.setState({fdGraphModal: true})}
											isRemoteWork={this.state.isRemoteWork}
											isRevisit={this.state.isRevisit}
											isSaving={this.state.ticketSave}
											userColors={this.state.userColors}
											updateFePkeys={(fePkeys) => {
												this.setState({fePkeys})
											}}
											optionalCallback={async (data) => {
												let model = new API.BuildClass(Types.Users._name, API.RequestType.READ);

												model.filter = {...this.state.fesInRangeFilter, 'data': data, 'filterDate': this.state.filterDate}
												let fesInRange = [];
												if (!this.state.isRevisit) {
													fesInRange = await model.submit(null, 'GET_ENGINEERS_IN_RANGE', true)
													if (fesInRange['message']) {
														fesInRange = fesInRange['message'];
													}
												}
												this.setState({fesInRange, override_warning:false, override_day_off_warning: false})
											}}
											forceOverrideWarning={() => this.setOverride()}
											selectedAddress={this.state.selectedAddress}
											fromDispatch={true}
										/>
									</div>
								</div>
								{this.state.reschedule_tickets.length > 0 && <div className={'row'}>
									<div className={'col-12'}>
										<b>This customer has a ticket that can be rescheduled.</b>
									</div>
									<div className={'col-12'}>
										<Collections.Reschedules
											history={this.props.history}
											regions={this.props.regions}
											forDispatch={true}
											dispatchData={this.state.reschedule_tickets}
										/>
									</div>
								</div>}
								<div className="row">
									<div className="col">
										<Objects.RemoteAppointments
											date={this.state.filterDate}
										/>
									</div>
								</div>
							</div>
						</div>
					</CardContent>
					<CardActions style={{justifyContent: "flex-end", padding: "14px"}}>
						<Button
							color="danger"
							onClick={this.handleClear}
						>
							Clear
						</Button>
						<Tooltip title={roles.includes(UserRoles.Admin) ? "Admins cannot create tickets." : this.state.customer?.blacklisted ? 'This customer is blacklisted. Please reach out to a manager for further instruction.' : ''} arrow>
							<Button
								disabled={this.state.isSaveDisabled || roles.includes(UserRoles.Admin) || this.state.customer?.blacklisted}
								color="primary"
								onClick={async (event) => {
									if (this.state.isSaveDisabled) return;
									this.state.isSaveDisabled = true;
									await this.handleSave(event)
								}}
							>
								Save
							</Button>
						</Tooltip>
					</CardActions>
				</Card>
				<Parts.Tickers.DispatchTicker/>
				<h4 className="section-title">Existing Customers</h4>
				<Collections.DispatchCustomers
					ref={this.tableRef}
					history={this.props.history}
					regions={this.props.regions}
					loadCustomer={this.loadCustomer}
					showCsv={roles.includes(UserRoles.Admin)}
					searching={this.state.search}
					updateSearch={(search) => this.setState({search})}
				/>
				{(this.processPhoneString(this.state.search) || this.processPhoneString(this.state.customer?.phone) || this.processPhoneString(this.state.customer?.phone_alt)) &&
					<div>
						<h4 className="section-title">Previous Phone Logs</h4>
						<Objects.MultiplePhoneLogs
							search={(this.processPhoneString(this.state.search) + '|' + this.processPhoneString(this.state.customer?.phone) + '|' + this.processPhoneString(this.state.customer?.phone_alt))}
						/>
					</div>}
			</React.Fragment>
		);
	}
}
export default CustomerQuickEdit;
